export type companyInfo = {
  companyCode: string;
  companyName?: string;
};

// YKC専用ページ
export type CompanyIdIssuanceInfo = {
  companyName: string;
  companyCode: string;
  status: string;
  mailSendLimit: number;
  smsSendLimit: number;
  createUser: string;
  createDatetime?: Date;
  updateUser: string;
  updateDatetime?: Date;
};

export type CompanyIdIssuanceSearchForm = {
  companyName: string;
  companyCode: string;
  status: string;
};

export type CompanyIdIssuanceInputForm = CompanyIdIssuanceInfo & {
  rentalAdminPasswordCheck?: string;
  adminPasswordCheck?: string;
};

export enum Status {
  Inactive = "Inactive",
  Active = "Active",
  Stop = "Stop",
}

export type SimSerialNoMappingSearchForm = {
  simId: string;
  serialNo: string;
  companyCode: string;
  companyName: string;
  status: string;
};

export type SimSerialNoMappingInsertForm = {
  index: number;
  simId: string;
  serialNo: string;
  result?: string;
  createUser?: string;
  updateUser?: string;
};

export type SimSerialNoMappingUpdateForm = {
  simId: string;
  serialNo: string;
  oldSimId: string;
  oldSerialNo: string;
  updateUser?: string;
  updateDatetime?: Date;
};

export type SimSerialNoMappingInfo = {
  simId: string;
  serialNo: string;
  companyCode: string;
  companyName: string;
  createUser?: string;
  createDatetime?: Date;
  updateUser?: string;
  updateDatetime?: Date;
};

export type ManagementSettingsInfo = {
  id?: number;
  value?: string;
  category?: string;
  key?: string;
};

// ログインユーザ情報
export type LoginUserInfo = {
  id?: number;
  userId: string;
  userPassword: string;
  userName?: string;
  adminFlg?: boolean;
  createUser?: string;
  createDatetime?: Date;
  updateUser?: string;
  updateDatetime?: Date;
};

export type SidebarProp = {
  title: string;
  icon: JSX.Element;
  link: string;
  subTitle: string[];
};

export type menuItem = {
  text: string;
  path?: string;
  icon: React.ComponentType;
  subItems?: {
    text: string;
    path?: string;
    subItems?: { text: string; path: string }[];
  }[]; // サブメニュー用のオプション
};

export type CompanyConfigsInfo = {
  id?: number;
  value?: string;
  category?: string;
  key?: string;
  createUser?: string;
  createDatetime?: Date;
  updateUser?: string;
  updateDatetime?: Date;
};

export type ManageBackupsInfo = {
  id: number;
  check: boolean;
  companyCode: string;
  companyName: string;
  createdAt: string;
  fileName: string;
  fileSize: number;
};

// メール・SMS送信履歴
export type MessageLogsForm = {
  schema: string;
  sentAt?: string;
  deliveryType?: string;
  notificationType?: string;
};

export type MessageLogsInfo = {
  id: number;
  check: boolean;
  sentAt: string;
  deliveryType: string;
  notificationType: string;
  recipient: string;
  body: string;
};

export type LoginProps = {
  setUserData: React.Dispatch<React.SetStateAction<LoginUserInfo>>;
};

// ログイン
export type LoginForm = {
  companyCode: string;
  id: string;
  password?: string;
};

// 作業者情報
export type WorkerBase = {
  id: number;
  tagId: string;
  name: string;
};

// 作業者情報
export type WorkerData = {
  tagId: string;
  name: string;
  battery: string;
  inDateTime?: Date;
  alertTime?: string;
  // 2026.02.25 add-s Y.Sakamoto
  recoverTime?: string;   // 復帰 or 強制退出時間
  durationSec?: number;   // 発生から復帰までの秒数
  // 2026.02.25 add-e Y.Sakamoto
};

// 作業者情報(alert用)
export type WorkerAlert = WorkerBase & {
  alertTime?: string;
};

// 作業者情報(作業者設定用)
export type WorkerInfo = WorkerBase & {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  createUser: string;
  createDatetime: Date;
  updateUser: string;
  updateDatetime: Date;
};

// エリア情報(エリア設定用)
export type AreaInfo = {
  id: number;
  simId: string;
  serialNo: string;
  magId: string;
  name: string;
  sortBy: number;
  colorCode: string;
  use: boolean;
  startDatetime: Date;
  endDatetime: Date;
  updateUser?: string;
  updateDatetime?: Date;
};

// エリア情報(エリア登録用)
export type InsertAreaType = {
  serialNo: string;
  name: string;
  sortBy: number;
  colorCode: string;
  userId?: string;
};

// メール情報(メール設定用)
export type MailInfo = {
  id?: number;
  mailName: string;
  mailAddress: string;
  alertCheckbox: boolean;
  connectCheckbox: boolean;
  telNumber?: string;
  smsCheckbox: boolean;
  createUser?: string;
  createDatetime?: Date;
  updateUser?: string;
  updateDatetime?: Date;
};

// ユーザ情報
export type MailData = {
  address: string;
  //name: string;
};

// API → 画面返却データ型
export type MainData = {
  serialNoDataList: MainContent[]; // sim単位表示用リスト
  areaNameDataList: MainContent[]; // エリア名単位表示用リスト
};

// API → 画面返却データ型
export type MainContent = {
  simId: string; // simID
  serialNo: string; // simID
  magId: string; // 磁界ID
  name: string; // エリア名
  aliveFlg: boolean; // 通信機が生きているか
  dangerNum: number; // ハーネス外してる作業者の数
  dashboardDataList: WorkerData[]; // dashboard表示用リスト
  alertDataList: WorkerData[]; // Alert表示用リスト
};

//  ★☆★☆レポート★☆★☆

// プルダウン表示用
export type AreaSimInfo = {
  simId: string; // simID
  name: string; // エリア名
};

export type AreaMagInfo = {
  magId: string; // 磁界ID
  name: string; // 磁界エリア名
};

// API → 画面返却データ型
export type ReportPulData = {
  tagIdList: string[]; // 登録中のタグID
  simIdList: AreaSimInfo[]; // 登録中のsimID
  magIdList: AreaMagInfo[]; // 登録中のmagID
};
